import { Text } from '@moia-dev/pace-web'
import type { HTMLAttributes, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export const TelematicDataValue = ({
  icon,
  value,
  unit,
  ariaLabel,
}: {
  icon: ReactElement
  value: string | undefined | null
  unit?: string
  ariaLabel: string
} & HTMLAttributes<HTMLSpanElement>) => {
  const { t } = useTranslation()
  return (
    // biome-ignore lint/a11y/useAriaPropsSupportedByRole: <auto ignored after biome migration>
    <div
      css={{
        width: 122,
      }}
      aria-label={ariaLabel}
    >
      <div
        css={theme => ({
          display: 'flex',
          alignItems: 'center',
          gap: theme.space.Space1,
          '& svg': {
            height: 20,
            width: 20,
          },
        })}
      >
        {icon}
        <Text
          css={{
            width: 122,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {value !== undefined
            ? `${value}${unit ?? ''}`
            : t('common_notApplicable_label')}
        </Text>
      </div>
    </div>
  )
}
